import styled from 'styled-components';
import { getColor } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const SectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;

  [role="tabpanel"]:not(.is-hidden) {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .tab-controls {
    button {
      height: 50px;
    }
  }
`;

export const SectionTitle = styled(Heading)`
  border-bottom: 1px solid ${getColor('borderBlack')};
`;
